import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

const loadAlerts = (params) => {
  return axios.get(API_URL + '/pntalert', {
    params,
  })
}

const checkAlert = (alert) => {
  return axios.put(API_URL + '/pntalert/check', alert)
}

const countAlerts = (params) => {
  return axios.get(API_URL + '/pntalert/count', {
    params,
  })
}
const api = {
  loadAlerts,
  checkAlert,
  countAlerts,
}

export default api
